import { render, staticRenderFns } from "./modalvideo.vue?vue&type=template&id=ce3e1374&scoped=true&"
import script from "./modalvideo.vue?vue&type=script&lang=js&"
export * from "./modalvideo.vue?vue&type=script&lang=js&"
import style0 from "./modalvideo.vue?vue&type=style&index=0&id=ce3e1374&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3e1374",
  null
  
)

export default component.exports